import React from 'react';
import { FadeIn } from './FadeIn';
import { XIcon, CheckIcon } from 'lucide-react';
export function ValueStack() {
  return <section className="py-16 sm:py-24 px-4 bg-running-surface" data-id="element-274">
      <div className="max-w-4xl mx-auto" data-id="element-275">
        <FadeIn data-id="element-276">
          <h2 className="text-3xl sm:text-5xl font-display font-bold text-center text-white mb-12" data-id="element-277">
            ¿Cuánto vale todo esto?
          </h2>
        </FadeIn>

        <div className="space-y-4 mb-12" data-id="element-278">
          {['Podés contratar un preparador físico para que te diseñe el programa de fuerza de tus corredores. Son varias horas de consultoría especializada. Solo para ese módulo.', 'Podés contratar a un nutricionista deportivo para que te asesore sobre el sistema de alimentación de tus alumnos. Más horas. Más costo.', 'Podés pagarle a un consultor de negocio para que te arme el sistema de posicionamiento, precios y captación de alumnos. Otro gasto importante.'].map((text, i) => <FadeIn key={i} delay={(i + 1) * 0.1} data-id="element-279">
              <div className="flex items-center gap-4 bg-running-dark p-4 sm:p-6 rounded-xl border border-running-muted/50 opacity-70" data-id="element-280">
                <div className="bg-red-500/10 p-2 rounded-full shrink-0" data-id="element-281">
                  <XIcon className="w-5 h-5 text-red-500" data-id="element-282" />
                </div>
                <p className="text-gray-300 text-sm sm:text-base" data-id="element-283">{text}</p>
              </div>
            </FadeIn>)}

          <FadeIn delay={0.4} data-id="element-284">
            <div className="flex items-center gap-4 bg-running-blue/10 p-5 sm:p-8 rounded-xl border border-running-blue shadow-[0_0_20px_rgba(61,232,255,0.1)]" data-id="element-285">
              <div className="bg-running-blue p-2 rounded-full shrink-0 text-running-dark" data-id="element-286">
                <CheckIcon className="w-6 h-6 sm:w-8 sm:h-8" strokeWidth={3} data-id="element-287" />
              </div>
              <p className="text-white font-bold text-lg sm:text-xl" data-id="element-288">
                O podés tener todo eso resuelto, en PDF, listo para usar desde
                hoy, por menos de lo que gastás en una entrada para una carrera.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}